module.exports = __webpack_public_path__ + "img/1.5e0e68d7.png";